import React, { useEffect, useState } from "react";
import { api, fmtINR, API } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

const STATUSES = ["pending", "paid", "shipped", "delivered", "cancelled"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (o, status) => {
    try {
      await api.put(`/admin/orders/${o.id}/status`, null, { params: { status } });
      toast.success("Status updated"); load();
    } catch (e) { toast.error("Failed to update"); }
  };

  return (
    <div data-testid="admin-orders">
      <h1 className="font-display text-3xl tracking-tight mb-6">Orders</h1>
      <div className="border border-white/10 bg-zinc-950 divide-y divide-white/10">
        {orders.map((o) => (
          <div key={o.id} className="p-4">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="font-mono text-xs text-white/50">#{o.id.slice(0, 8)}</p>
                <p className="font-display mt-1">{o.address.full_name} · {o.contact}</p>
                <p className="text-xs text-white/50 mt-0.5">{o.address.city}, {o.address.state} · {o.address.pincode}</p>
                <p className="text-xs text-white/40 mt-1 font-mono">{new Date(o.created_at).toLocaleString("en-IN")}</p>
              </div>
              <div className="text-right shrink-0">
                <p className="font-mono text-lg">{fmtINR(o.total_inr)}</p>
                <div className="mt-2">
                  <Select value={o.status} onValueChange={(v) => setStatus(o, v)}>
                    <SelectTrigger className="h-8 bg-black border-white/10 w-[130px] mono-label"><SelectValue/></SelectTrigger>
                    <SelectContent className="bg-zinc-950 border-white/10">
                      {STATUSES.map((s) => <SelectItem key={s} value={s} className="mono-label">{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
            <div className="mt-3 grid gap-1 text-xs text-white/70">
              {o.items.map((i, idx) => (
                <div key={idx} className="flex justify-between border-t border-white/5 pt-1">
                  <span>{i.title} · <span className="text-white/50">{i.variant_name}</span> × {i.qty}</span>
                  <span className="font-mono">{fmtINR(i.price_inr * i.qty)}</span>
                </div>
              ))}
            </div>
            {o.attachments && o.attachments.length > 0 && (
              <div className="mt-3">
                <p className="mono-label text-white/50 mb-2">Customer photos</p>
                <div className="flex flex-wrap gap-2">
                  {o.attachments.map((path, idx) => (
                    <a key={idx} href={`${API}/files/${path}`} target="_blank" rel="noopener noreferrer" className="h-16 w-16 border border-white/10 bg-zinc-900 overflow-hidden hover:border-blue-500 transition-colors">
                      <img src={`${API}/files/${path}`} alt="" className="w-full h-full object-cover"/>
                    </a>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
        {orders.length === 0 && <div className="p-8 text-center text-white/50 text-sm">No orders yet.</div>}
      </div>
    </div>
  );
}
